import React from 'react'

export const ToggleRightSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.01172 12.011C7.01172 10.302 8.2604 8.99991 9.70266 8.99991H16.0845C17.5268 8.99991 18.7755 10.302 18.7755 12.011C18.7755 13.72 17.5268 15.022 16.0845 15.022H9.70266C8.2604 15.022 7.01172 13.72 7.01172 12.011ZM9.70266 7.99991C7.6203 7.99991 6.01172 9.84178 6.01172 12.011C6.01172 14.1802 7.6203 16.022 9.70266 16.022H16.0845C18.1669 16.022 19.7755 14.1802 19.7755 12.011C19.7755 9.84178 18.1669 7.99991 16.0845 7.99991H9.70266ZM15.6707 14.8586C17.2427 14.8586 18.5171 13.5842 18.5171 12.0123C18.5171 10.4403 17.2427 9.16592 15.6707 9.16592C14.0987 9.16592 12.8244 10.4403 12.8244 12.0123C12.8244 13.5842 14.0987 14.8586 15.6707 14.8586Z"
        fill={props.fill || 'black'}
      />
    </svg>
  )
}
